module.exports = __webpack_public_path__ + "Flama-Bold.woff2?75d5bcc561f78a3b29ae5deebf427f28";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Bold.woff2
// module id = 905
// module chunks = 0